(() => {
  if (window.customElements.get('bundle-product-picker')) {
    return;
  }

  class BundleProductPicker extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-bundle-message]');
      this.selects = Array.from(this.querySelectorAll('[data-bundle-option-position]'));
      this.variants = JSON.parse(this.querySelector('[data-bundle-variants]')?.textContent || '[]');

      if (this.selects.length === 0 || this.variants.length === 0) {
        return;
      }

      this.selectFirstAvailableVariant();
      this.syncAllVariantInputs(this.findSelectedVariant());
      this.bindEvents();
      this.updateFromBundleDropdowns();
    }

    bindEvents() {
      this.selects.forEach((select) => {
        select.onchange = () => this.updateFromBundleDropdowns();
        select.oninput = () => this.updateFromBundleDropdowns();
      });
    }

    selectFirstAvailableVariant() {
      const firstAvailableVariant = this.variants.find((variant) => variant.available) || this.variants[0];

      if (firstAvailableVariant) {
        this.syncBundleDropdowns(firstAvailableVariant);
      }
    }

    getSelectedLabels() {
      return this.selects
        .slice()
        .sort((a, b) => Number(a.dataset.bundleOptionPosition) - Number(b.dataset.bundleOptionPosition))
        .map((select) => select.selectedOptions[0]?.dataset.optionLabel || select.selectedOptions[0]?.textContent.trim() || '');
    }

    findSelectedVariant() {
      const selectedLabels = this.getSelectedLabels();

      return this.variants.find((variant) => {
        return selectedLabels.every((label, index) => variant.options[index] === label);
      });
    }

    updateFromBundleDropdowns() {
      const variant = this.findSelectedVariant();

      if (!variant) {
        this.updateButtons(null);
        this.showMessage('This bundle combination is unavailable.', true);
        return;
      }

      this.syncAllVariantInputs(variant);
      this.updateButtons(variant);
      this.showMessage(variant.available ? '' : 'This bundle combination is sold out.', !variant.available);
    }

    updateBundleDropdownsFromVariantId(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));

      if (!variant) {
        return;
      }

      this.syncBundleDropdowns(variant);
      this.syncAllVariantInputs(variant);
      this.updateButtons(variant);
    }

    syncBundleDropdowns(variant) {
      this.selects.forEach((select, index) => {
        const optionLabel = variant.options[index];

        Array.from(select.options).forEach((option) => {
          const label = option.dataset.optionLabel || option.textContent.trim();

          if (label === optionLabel) {
            select.value = option.value;
          }
        });
      });
    }

syncAllVariantInputs(variant) {
  if (!variant) {
    return;
  }

  document.querySelectorAll('[name="id"]').forEach((input) => {
    input.value = String(variant.id);
    input.setAttribute('value', String(variant.id));
  });

  document.querySelectorAll('[id^="independent-sticky-select-"]').forEach((select) => {
    select.value = String(variant.id);
  });
}

    updateButtons(variant) {
      document.querySelectorAll('button[type="submit"], #independent-sticky-btn-' + Shopify.theme.sectionId).forEach((button) => {
        if (!variant) {
          button.disabled = true;
          button.textContent = 'Unavailable';
          return;
        }

        if (variant.available) {
          button.disabled = false;
          button.textContent = 'Add to cart';
        } else {
          button.disabled = true;
          button.textContent = 'Sold out';
        }
      });
    }

    showMessage(message, isError) {
      if (!this.message) {
        return;
      }

      this.message.textContent = message;
      this.message.classList.toggle('is-error', Boolean(isError));
      this.message.hidden = message === '';
    }
  }

  window.customElements.define('bundle-product-picker', BundleProductPicker);
})();